const ROLE_ALIASES = {
  org_user: [
    "org_user",
    "org user",
    "user",
    "member",
    "team member",
    "team_member",
    "organization user",
    "organization member",
  ],
  org_admin: [
    "org_admin",
    "org admin",
    "admin",
    "administrator",
    "organization admin",
  ],
};

export function resolveRoleInput(input, roles = []) {
  const raw = String(input || "").trim();
  if (!raw) return { matched: true, value: "org_user" };

  const normalized = raw.toLowerCase().replace(/\s+/g, " ").trim();
  const underscored = normalized.replace(/\s+/g, "_");

  if (underscored === "org_user" || underscored === "org_admin") {
    return { matched: true, value: underscored };
  }

  for (const role of roles) {
    const value = String(role.value || "").toLowerCase().trim();
    const label = String(role.label || "").toLowerCase().trim();
    if (normalized === value || normalized === label || underscored === value) {
      return { matched: true, value: role.value };
    }
  }

  for (const [value, aliases] of Object.entries(ROLE_ALIASES)) {
    if (aliases.includes(normalized) || aliases.includes(underscored)) {
      return { matched: true, value };
    }
  }

  return { matched: false, value: raw };
}

export function roleImportHint(roles = []) {
  const labels = roles.length
    ? roles.map((r) => `${r.value} (${r.label || r.value})`).join(", ")
    : "org_user (Member/Team Member), org_admin (Admin)";
  return labels;
}
